/** A ranger's perk and trait modifiers (04 §4): the neutral set, and merging a partial one onto it. */

import { PERKS } from './tuning';
import type { SimMods } from './types';

export function defaultMods(): SimMods {
  return {
    aimSpreadStill: 1, aimSpread: 1, reloadTime: 1, carbineRange: 1, grenadeRange: 1, bombPlaceTime: 1,
    staminaPool: 1, staminaRecovery: 1, runSpeed: 1, crawlSpeed: 1, walkNoise: 1, footprintFade: 1, crawlDetection: 1,
    firstAidTime: 1, bleedOutTime: 1, carryBonus: 0, extraFirstAidHeal: 0, mineSenseRadius: 0,
    wireImmune: false, knifeReachBonus: 0, silentFrontalKnife: false, parafoilSteering: 1, podDrift: 1,
    disguiseScrutiny: 1, luckyCharges: 0,
    burstFreeRounds: 0, lawDeviation: 1, extraLaws: 0, weaponRaiseTime: 1, cookOff: false, salvager: false,
    nightPenalty: 1, wadeFatigue: 1, fireRate: 1, alertedSpread: 1, hearingRadius: 1,
  };
}

export function withMods(partial: Partial<SimMods> | undefined): SimMods {
  return { ...defaultMods(), ...(partial ?? {}) };
}

/**
 * Mine Sense: how far ahead he can read the ground right now. Its text always promised less at a
 * run - "(3 m while running)" - and the renderer only ever asked for the standing figure, so the
 * clause was decoration (ROUND5 §3.9). You cannot study the ground with your head up and going.
 */
export function senseRadius(mods: Pick<SimMods, 'mineSenseRadius'>, running: boolean): number {
  if (mods.mineSenseRadius <= 0) return 0;
  return Math.max(0, mods.mineSenseRadius - (running ? PERKS.mineSenseRunPenalty : 0));
}
